import { z } from "zod/v4-mini";

import type { Schema } from "@/utils/zodUtils.ts";

export type FeatureFlags = Record<string, boolean>;

export const featureFlagsSchema: Schema<FeatureFlags> = z.record(z.string(), z.boolean());
